<template>
  <div>

  <div class="login-page" v-if="showAddress == false">
    <div v-if="showAmount">
      <form>
        <div style="clear:both"/>
        <p class="am-title">Amount</p>
        <a @click="subs">
          <svg class="minus">
            <use xlink:href="#minus"/>
          </svg>
        </a>
        <input type="text" v-model="orderAmount"/>
        <a @click="add">
          <svg class="add">
            <use xlink:href="#plus"/>
          </svg>
        </a>
        <!-- <p class="button next" v-if="!defAddress" @click="setAddress">Next</p> -->
        <p class="button next" @click.prevent="nextConfirm">Next</p>
        <p class="button cancel" @click="close">Cancel</p>
      </form>
    </div>
    <div v-if="showConfirm">
      <a class="back" @click="back()"><img src="@/assets/back.svg"/></a>
      <p class="login-title">Confirm Order</p>
      <form>
        <div class="address">
          <p class="recipient"><span>{{this.defAddress.name}}</span> {{this.defAddress.phone}}</p>
          <p class="address-info">{{(this.defAddress.country + " " + this.defAddress.province + " " + this.defAddress.city + " " + this.defAddress.area + " " + this.defAddress.address).length>35?(this.defAddress.country + " " + this.defAddress.province + " " + this.defAddress.city + " " + this.defAddress.area + " " + this.defAddress.address).substring(0,36) + " ...":this.defAddress.country + " " + this.defAddress.province + " " + this.defAddress.city + " " + this.defAddress.area + " " + this.defAddress.address}}</p>
          <div class="setAddress">
            <a @click="setAddress">
              <svg class="toAddress">
                <use xlink:href="#back"/>
              </svg>
            </a>
            <!-- <a @click="setAddress"><img src="@/assets/back.svg"/></a> -->
          </div>
        </div>
        <div class="orders" v-if="fromSC == 1" v-for="data in proList">
          <div class="imgbox">
            <img :src="data.img"/>
          </div>
          <table>
            <tr>
              <td colspan="2" style="fontWeight:bold; fontSize:18px;">{{data.product_name}}</td>
            </tr>
            <tr>
              <td class="test">Price:</td>
              <td>USD {{data.price}} x {{data.number}} pc (s)</td>
            </tr>
            <tr>
              <td>Total:</td>
              <td>USD {{data.number * data.price}}</td>
            </tr>
          </table>
        </div>
        <div class="orders" v-if="fromSC == 0">
          <div class="imgbox">
            <img :src="imgsrc"/>
          </div>
          <table>
            <tr>
              <td colspan="2" style="fontWeight:bold; fontSize:18px;">{{name.length > 28?name.substring(0,28)+' ...':name}}</td>
            </tr>
            <tr>
              <td class="test">Price:</td>
              <td>USD {{price}} x {{orderAmount}} pc (s)</td>
            </tr>
            <tr>
              <td>Total:</td>
              <td>USD {{orderAmount * price}}</td>
            </tr>
          </table>
        </div>
        <div class="confirm">
          <p @click="confPay" class="button conf">Confirm</p>
          <!-- <p @click="back" class="button conf">Back</p> -->
        </div>
      </form>
    </div>
  </div>
  <manage-address v-if="showAddress" fromConf="1" @back="closeAddress" @close="close()"/>



  <svg display="none">
    <symbol height="20px" viewBox="0 0 512 512" width="20px" xmlns="http://www.w3.org/2000/svg" id="plus">
      <path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469s132.667969-26.628906 181.019531-74.980469c48.351563-48.351562 74.980469-112.640625 74.980469-181.019531s-26.628906-132.667969-74.980469-181.019531zm-181.019531 397.019531c-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216-96.898438 216-216 216zm20-236.019531h90v40h-90v90h-40v-90h-90v-40h90v-90h40zm0 0">
      </path>
    </symbol>
    <symbol height="20px" viewBox="0 0 512 512" width="20px" xmlns="http://www.w3.org/2000/svg" id="minus">
      <path d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
    </symbol>
    <symbol height="20px" width="20px" viewBox="0 0 240.823 240.823" xmlns="http://www.w3.org/2000/svg" id="back">
      <path id="Chevron_Right" d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
    		l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
    		C52.942,116.507,52.942,124.327,57.633,129.007z"/>
    </symbol>
  </svg>
</div>
</template>
<script>
import {GetAddress, GetOrderByCart} from '@/api/index.js'
import ManageAddress from './ManageAddress.vue'
  export default {
    name: 'ConfirmPayment',
    data() {
      return {
        orderAmount:1,
        showAmount:true,
        showConfirm:false,
        defAddress:null,
        showAddress:false,
        proList:null,
      };
    },
    components:{
      ManageAddress,
    },
    props:{
      price:{
        type:String,
      },
      name:{
        type:String,
      },
      imgsrc:{
        type:String,
      },
      fromSC:{
        type:String,
        default:'0'
      },
      pid:{
        type:Array,
      },
      oType:{
        type:Number,
      }
    },
    created(){
      this.initAddress()
      console.log('fromSC= ' + this.fromSC);
      if(this.fromSC == 1){
        this.initSC();
      }
    },
    methods:{
      initSC(){
        this.showAmount=false;
        this.showConfirm=true;
        GetOrderByCart({'productid':this.pid}).then(res => {
          this.proList = res.data.product;
        })
      },
      closeAddress(){
        this.showConfirm = true;
        this.showAddress = false;
        this.initAddress();
      },
      setAddress(){
        // this.showConfirm = false;
        this.showAddress = true;
        this.showAmount = false;
      },
      initAddress(){
        GetAddress().then(res => {
          for(let val in res.data){
            if(res.data[val].status == 1){
              this.defAddress = res.data[val];
              console.log('data: ' + this.defAddress.name);
            }
          }
          if(this.fromSC == 1){
            if(this.defAddress == null){
              window.alert('please select your default address!')
              this.setAddress();
            }
          }
        })
      },
      close(){
        this.$emit('closePay');
      },
      add(){
        this.orderAmount++;
      },
      subs(){
        if(this.orderAmount > 1){
          this.orderAmount--;
        }
      },
      nextConfirm(){
        if(this.oType == 0){
          window.alert('order requested!');
          this.close();
        }
        this.showAmount = false;
        this.showConfirm = true;
        if(this.defAddress == null){
          window.alert('please select your default address!')
          this.setAddress();
        }
      },
      back(){
        if (this.fromSC == 1){
          this.$emit('back');
        }else{
          this.showAmount = true;
          this.showConfirm = false;
        }
      },
      confPay(){
        window.alert("Order Requested!");
        this.showConfirm = false;
        this.close();
      }
    },
  };
</script>
<style lang="" scoped>
  .login-page{
    /* width:100%; */
    width:450px;
    margin:0 auto;
    position: fixed;
    background: #C4CCCE;
    border-radius: 15px;
    /* text-align: left; */
    top:15%;
    left:50%;
    transform: translateX(-50%);
    padding:25px 0;
    z-index: 110;
    max-height: 550px;
    overflow: auto;
  }
  input[type="text"]{
    padding:10px;
    width:42%;
    text-align: center;
    border:1px solid #d2d2d2;
    border-radius: 15px;
    margin:0 8px;
    margin-bottom: 20px;
    display: inline-block;
    border:none;
  }
  input:focus{
    outline: none;
    /* border-color: red; */
  }
  .back img{
    width: 20px;
    margin-left: 10px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .am-title{
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #3C4245;
  }
  .login-title{
    /* letter-spacing: 2px; */
    font-size: 25px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    vertical-align: middle;
  }
  .button{
    width: 63%;
    color:#fff;
    font-weight:bold;
    margin:0 auto;
    line-height: 40px;
    margin-bottom: 5px;
    border-radius: 15px;
    background: #5F6769;
    color:#eee
  }

.next{
  background: #5F6769;
}

.cancel{
  background: #9D9D9D;
}

  .conf{
    width: 31%;
    display: inline-block;
  }
  .button:hover{
      cursor: pointer;
      opacity: 0.8;
  }
  .add,.minus{
    fill: #5F6769;
  }
  .add:hover,.minus:hover{
    cursor: pointer;
      fill: #719192;
  }

  svg {
    width: 20px;
    height: 20px;
    /* background: red; */
  }

  .minus, .add{
    vertical-align: middle;
    display: inline-block;
  }

  .addd{
    background: red;
    width: 3%;
    height: 20px;
  }

/* ORDERS */
  .orders{
    margin: 0 auto;
    background: #fff;
    text-align: left;
    width: 88%;
    padding-top: 5%;
    padding-left:5%;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .imgbox{
    width: 20%;
    min-width: 86.4px;
    max-width: 91.6px;
    float: left;
  }
  .imgbox img{
    width:100%;
    border-radius: 10px;
  }

  table{
    display: inline-block;
    text-align: left;
    width: 66%;
    font-size: 12px;
    margin-left: 4%;
    /* background: lavender; */
    border-spacing: 0 10px;
    margin-bottom: 20px;
    color:#5F6769;
  }
  .test{
    width: 35%;
  }

  .border{
    border-bottom: 1px solid #000;
    /* background: red; */
  }
/* END OF ORDERS--------------------- */

/* CONFIRM */
  .confirm{
    text-align: right;
  }
  .conf{
    text-align: center;
    margin-right: 4%;
    margin-top: 20px;
  }
/* END OF CONFIRM----------------- */

  .total{
    font-weight: bold;
    font-size: 22px;
    margin-top: 10px;
  }

/* ADDRESS   */
  .address{
    background: #7B8588;
    text-align: left;
    width: 88%;
    margin: 0 auto;
    padding: 3% 0 3% 5%;
    margin-bottom: 20px;
    border-radius: 10px;
    position: relative;
    margin-top: 20px;
    color:#eee;
  }
  .address p {
    margin: 0;
    font-size: 12px;
  }
  .recipient span{
    font-size: 16px!important;
  }
  .recipient{
    margin-bottom: 5px!important;
  }

  .toAddress {
    width: 20px;
    fill:#eee;
    transform: rotate(180deg);
    position: absolute;
    top:20px;
    right:20px;
  }
  .toAddress:hover{
    cursor: pointer;
    fill:#719192;
  }
/* END OF ADDRESS------------------ */

</style>



// WEBPACK FOOTER //
// src/components/ConfirmPayment.vue